import type { BooleanSwitch } from "types";

export const toBooleanSwitch = (value: unknown): BooleanSwitch => Number(
    value
) as BooleanSwitch;
